import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Notice from '../notice.vue';
import ResponsiveImage from '../../responsive-image.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Notice, null, {
    default: _withCtx(() => [
      _createVNode(ResponsiveImage, {
        image: require('./pc.png'),
        "mobile-image": require('./m.png'),
        "image-webp": require('./pc.webp'),
        "mobile-image-webp": require('./m.webp'),
        "image-w": 1086,
        "image-h": 1170,
        "mobile-image-w": 1059,
        "mobile-image-h": 1107
      }, null, 8, ["image", "mobile-image", "image-webp", "mobile-image-webp"])
    ]),
    _: 1
  }))
}
}

})